import {iframeReady} from './youtubeApiInit';

const bannerVideo = function(bannerItem) {
  var autoplaySpeed = 5000,
    $bannerCarousel = $(bannerItem);

  if ($bannerCarousel.length === 0) return;    

  function videoReady($video) {
    var ready = false;

    if ($video.length) {
      ready = $video[0].readyState > 0;
    }

    return ready;
  }

  function banerPlay() {
    $bannerCarousel.on('init', function() {      
      var $video = $(this).find('.slick-slide.slick-current.slick-active').find('video'),
        $videoIframe = $(this).find('.slick-slide.slick-current.slick-active').find('.video-iframe');

      function play() {
        if ($video.length && videoReady($video)) {
          var vid = $video[0];
  
          vid.muted = true;
          vid.play();
        } else if($video.length) {
          setTimeout(() => {
            play();
          }, 500);
        }
      }
      
      play();

      if ($videoIframe.length) {        
        function slickReady() {
          setTimeout(() => {            
            if ($bannerCarousel[0].slick !== undefined) {
              $bannerCarousel.slick('slickPause');
            } else {
              slickReady();
            }
          }, 100);
        }    
        slickReady();  

        iframeReady(function(e) {
          setTimeout(() => {
            e.mute();
            e.playVideo();
          }, 1000);
        }, $videoIframe.prop('id'));
      }

    });
  }

  function banerPauseCarousel() {
    var $videos = $bannerCarousel.find('video'),
      $videoIframe = $bannerCarousel.find('.video-iframe'),
      items = $bannerCarousel.find('.item').length;

    function next(element) {
      var init = $bannerCarousel.hasClass('slick-initialized');

      if (init) {
        window.bannerVideoTimer2 = setTimeout(function () {
          if (items <= 1) {
            if ($videos.length && videoReady($videos)) {
              $videos[0].muted = true;
              $videos[0].play();
            }

            if ($videoIframe.length) {
              youTubePlayers.forEach(e => {
                if (e.a.id === $videoIframe.prop('id')) {
                  e.mute();
                  e.playVideo();
                }
              });
            }
          } else {
            $bannerCarousel.slick('slickNext');
            $bannerCarousel.slick('play');
          }

        }, 1000);
      }
    }

    $videos.each(function(index, element) {
      var vid = $(element)[0];

      vid.onplaying = function() {
        var init = $bannerCarousel.hasClass('slick-initialized');

        if (init) {
          $bannerCarousel.slick('slickPause');
        }
      };

      $(element)[0].onended = function () {
        next(element);
      };
    });

    //if IE
    // if (navigator.userAgent.indexOf('MSIE') !== -1 ||
    //   navigator.appVersion.indexOf('Trident/') > 0) {
    //   /* Microsoft Internet Explorer detected in. (6-11) */

    //   $videos.each(function(index, element) {
    //     $(element)[0].onended = function() {
    //       next(element);
    //     };
    //   });
    // }

    $videoIframe.each(function(index, element) {
      iframeReady(function(e) {
        e.addEventListener('onStateChange', function (e) {
          if (e.data === 1) {
            var init = $bannerCarousel.hasClass('slick-initialized');

            if (init) {
              $bannerCarousel.slick('slickPause');
            }
          }

          if (e.data === 0) {
            next(element);
          }
        }, false);
      }, element.id);
      
    });
  }

  function banerBeforeChange() {
    $bannerCarousel.on('beforeChange', function(event, slick, currentSlide) {
      var $video = $(this).find('.slick-slide.slick-current.slick-active').find('video'),
        $videoIframe = $(this).find('.slick-slide.slick-current.slick-active').find('.video-iframe');

      if ($video.length && videoReady($video)) {
        var vid = $video[0];

        vid.currentTime = 0;
        vid.pause();
      }

      if ($videoIframe.length) {
        iframeReady(function(e) {
          e.stopVideo(); 
        }, $videoIframe.prop('id'));
      }
    });
  }

  function banerAfterChange() {
    var $thisSlider = $bannerCarousel,
      $bannerMenu = $('#banner-menu');

    $thisSlider.on('afterChange', function(event, slick, currentSlide) {
      var $video = $(this).find('.slick-slide.slick-current.slick-active').find('video'),
        $videoIframe = $(this).find('.slick-slide.slick-current.slick-active').find('.video-iframe'),
        slides = $(".slider-for .slick-track > .slick-slide").length;

      if (window.bannerVideoTimer) {
        clearTimeout(window.bannerVideoTimer);
      }

      if (window.bannerVideoTimer2) {
        clearTimeout(window.bannerVideoTimer2);
      }

      if ($video.length && videoReady($video)) {
        var vid = $video[0];

        vid.currentTime = 0;
        vid.muted = true;
        vid.play();
      } else if ($videoIframe.length) {
        iframeReady(function(e) {
          e.mute();
          e.playVideo();
        }, $videoIframe.prop('id'));
      } else {
        window.bannerVideoTimer = setTimeout(function() {
          $bannerCarousel.slick('slickNext');
          $bannerCarousel.slick('play');
        }, autoplaySpeed);
      }

      function updateMenu() {
        var inFocus = $thisSlider.find('.slick-current').attr('data-slick-index');

        $bannerMenu.find('.slick-current').removeClass('slick-current');
        $bannerMenu.find('.slick-slide[data-slick-index="' + inFocus + '"]').trigger('click');
      }
      // updateMenu();

    });
  }

  function banerInit() {
    if ($bannerCarousel.length === 0) return;

    banerPauseCarousel()
    banerPlay();
    banerBeforeChange()
    banerAfterChange();
  }

  banerInit();
};

export default bannerVideo;


// WEBPACK FOOTER //
// ./src/js/components/bannerVideo.js